module.exports = __webpack_public_path__ + "img/2-3.f00206fa.webp";